import styled from "styled-components";
import { Text, BoldHeader2 } from "src/apps/components/typography/Texts";
import { T } from "src/apps/components/i18n/Translation";

import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import { useTheme } from "src/apps/providers/ThemeStore";
import { MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";
import { useIsMedia } from "src/apps/hooks/useIsMedia";
import { colors } from "@permisso/permisso-components";

interface OrdersSectionProps {
  title: string;
  description: string;
  status?: "completed" | "in_progress";
}

export const DefaultOrdersSectionHeader = ({ title, description, status }: OrdersSectionProps) => {
  const { successColor, blackColor } = useTheme();
  const isCompleted = status === "completed";
  const { isMobile } = useIsMedia();

  return (
    <ContentHeader>
      <TitleContainer>
        {isCompleted && !isMobile ? (
          <Icon size={ICON_SIZES.s20} color={successColor} path={ICON_PATHS.CHECK_CIRCLE_THIN} />
        ) : null}
        <BoldHeader2 $color={blackColor}>
          <T k={title} />
        </BoldHeader2>
      </TitleContainer>
      {description ? (
        <Text $color={colors.grey700}>
          <T k={description} />
        </Text>
      ) : null}
    </ContentHeader>
  );
};

const ContentHeader = styled.div`
  display: flex;
  padding: 1.75rem;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    padding: 0rem 0rem;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
